<template>
  <article class="manage-platform">
    <ul class="tab-service-detail">
      <li :class="{'on':time_interval===1}" @click="onShiftTap(1)"><a href="javascript:void(0);">今日</a></li>
      <li :class="{'on':time_interval===2}" @click="onShiftTap(2)"><a href="javascript:void(0);">最近7天</a></li>
      <li :class="{'on':time_interval===3}" @click="onShiftTap(3)"><a href="javascript:void(0);">本月</a></li>
    </ul>
    <group>
      <cell title="统计对象" class="status" @click.native="showStaff = true" is-link>
        <span slot="value">{{statisticName}}</span>
      </cell>
    </group>
    <group title="今日动态" class="status">
      <cell title="总呼出量">{{statistics.call_num}}</cell>
      <cell title="已联系客户数">{{statistics.contact_customer_num}}</cell>
      <cell title="新增逾期任务数">{{statistics.overdue_task_num}}</cell>
    </group>
    <group title="今日战绩" class="status">
      <cell title="总接待量">{{statistics.reception_num}}批</cell>
      <cell title="首次接待量">{{statistics.first_time_reception_num}}批</cell>
      <cell title="签单客户数">{{statistics.sign_bill_num}}位</cell>
      <cell title="确认成交数">{{statistics.deal_num}}</cell>
    </group>
    <popup v-model="showStaff" style="height: 100%;overflow: auto;">
      <group title="全部">
        <checker v-model="assignee_id">
          <checker-item class="appointment-item" v-for="(item, index) in sales" :key="index" :value="item.id" @on-item-click="selectStaff(item)">
            <cell class="appointment-adviser">
              <img slot="icon" class="adviser-img" :src="item.avatar" />
              <span slot="after-title" class="appointment-title">{{item.name}}</span>
              <icon type="success_no_circle" v-if="assignee_id === item.id"></icon>
            </cell>
          </checker-item>
        </checker>
      </group>
    </popup>
  </article>
</template>

<script>
import {
  Icon,
  Popup,
  Checker,
  CheckerItem,
  Cell,
  Group
} from '@lx-frontend/cvux'
import authApi from '../../../common/auth'

export default {
  components: {
    Icon,
    Popup,
    Checker,
    CheckerItem,
    Cell,
    Group
  },
  data () {
    return {
      statisticName: '全部',
      time_interval: 1,
      summary: {
        'pending_approve_deal_num': 0,
        'pending_approve_fail_num': 0
      },
      statistics: {
        'call_num': 0,
        'contact_customer_num': 0,
        'deal_num': 0,
        'first_time_reception_num': 0,
        'overdue_task_num': 0,
        'reception_num': 0,
        'sign_bill_num': 0
      },
      sales: [],
      authArr: [authApi.saleManage.sale_potential_customer_manage, authApi.saleManage.sale_potential_customer_view_all],
      showStaff: false,
      assignee_id: ''
    }
  },
  created () {
    this.$store.state.promiseAuth.then(auth => {
      let permission = authApi.haveEveryAuth(this.authArr, auth.authList)
      if (permission) {
        this.$rest.saleManage.getSummary().then(res => {
          if (res.code === 0) {
            this.summary = res.data
          }
        }).then(() => {
          this.$rest.saleManage.getCustomersStatistics({
            time_interval: this.time_interval,
            assignee_id: this.assignee_id
          }).then(res => {
            if (res.code === 0) {
              this.statistics = res.data
            }
          })
        })
        this.$rest.saleManage.getSales().then(res => {
          if (res.code === 0) {
            this.sales = res.data
          }
        })
      } else {
        this.showToast('您尚未获得相关权限')
      }
    })
  },
  methods: {
    onShiftTap (timeInterval) {
      if (timeInterval === this.time_interval) return
      this.time_interval = timeInterval
      this.$rest.saleManage.getCustomersStatistics({
        time_interval: timeInterval,
        assignee_id: this.assignee_id
      }).then(res => {
        if (res.code === 0) {
          this.statistics = res.data
        }
      })
    },
    // 选择员工
    selectStaff (item) {
      this.assignee_id = item.id
      this.statisticName = item.name
      this.showStaff = false
      this.$rest.saleManage.getCustomersStatistics({
        time_interval: this.time_interval,
        assignee_id: this.assignee_id
      }).then(res => {
        if (res.code === 0) {
          this.statistics = res.data
        }
      })
    }
  }
}
</script>
<style lang="less">
  @import "../../../stylesheets/modules/salemanage/sale";
</style>
